import React, { useState, useContext, useEffect } from 'react';
import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import '../../styles/otherpage.css';
import feedbacksvg from '../../assets/imgs/feedback.svg';
import Footer from '../Layouts/Footer';
import { GlobalErrorHandler } from '../Layouts/GlobalErrorHandler';
import { SuccessHandler } from '../Layouts/SuccessHandler';
import { GlobalContext } from '../../contexts/states/GlobalState';
import Spinner from '../svgs/Spinner';
import CallToActionButton from '../Layouts/CallToActionButton';

export const FeedbackPage = () => {
  const {
    error,
    setError,
    loading,
    addFeedback,
    globalError,
    feedbackSuccess,
  } = useContext(GlobalContext);

  const [feedback, setFeedback] = useState('');
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [formError, setFormError] = useState(false);

  const verifyUserInput = (e) => {
    e.preventDefault();

    if (!feedback || !fullname || !email) {
      return setFormError('All fields are required');
    }

    addFeedback(fullname, email, feedback);
  };

  useEffect(() => {
    let t;
    if (formError) {
      t = setTimeout(() => {
        setFormError(false);
      }, 6000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [formError]);

  useEffect(() => {
    let t;
    if (error) {
      t = setTimeout(() => {
        setError(false);
      }, 6000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [error]);

  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header action='/download' />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>Tell us what you think about lionTaxi</span>
            </h1>
            <h3>your opinion matters!</h3>
            <div className='store-buttons'>
              <CallToActionButton store={true} />
            </div>
          </div>
          <div className='svg-content'>
            <img
              src={feedbacksvg}
              width={550}
              height={438}
              alt='app screenshot'
            />
          </div>
        </div>
      </header>
      <main className='home-main privacy diff-form'>
        <h2>Tell us about your experience</h2>
        <p>Got any suggestions? let us know</p>
        <form onSubmit={verifyUserInput}>
          <div className='inline-block'>
            <div>
              <label htmlFor='fullname'>Full Name *</label>
              <input
                type='text'
                id='fullname'
                name='fullname'
                placeholder='e.g John Doe'
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
                required={true}
              />
            </div>
            <div>
              <label htmlFor='email'>Email *</label>
              <input
                type='email'
                id='email'
                name='email'
                placeholder='e.g john_doe@gmail.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required={true}
              />
            </div>
          </div>

          <textarea
            required={true}
            placeholder='Talk to us!'
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          ></textarea>

          <button
            className='form-submit'
            onClick={verifyUserInput}
            disabled={loading}
          >
            {loading ? <Spinner size={25} /> : 'Submit Feedback'}
          </button>
          {formError && (
            <div className='form-error'>
              <p>{formError}</p>
            </div>
          )}
          {error && (
            <div className='form-error'>
              <p>{error}</p>
            </div>
          )}
        </form>
      </main>
      <Footer />
      <div className='connection-error-handler'>
        <div className={`modal-con ${globalError && 'active'}`}>
          {globalError && (
            <GlobalErrorHandler error={globalError} context={GlobalContext} />
          )}
        </div>
      </div>
      <div className='success-handler'>
        <div className={`modal-con ${feedbackSuccess && 'active'}`}>
          {feedbackSuccess && (
            <SuccessHandler
              msg={'Feedback Submitted'}
              context={GlobalContext}
            />
          )}
        </div>
      </div>
    </div>
  );
};

// TODO: prevent spam
